import React, { memo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { getCustomerStates } from 'utlis/Apis/Customers_API'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'
import FeatherIcon from 'feather-icons-react';
import AppFormikTextarea from 'utlis/helpers/forms/AppFormikTextarea'

function DestinationZonesDetails(props) {
    const { formik, countries } = props
    const [states, setStates] = useState([])
    const getStates_ = (country_id) => {
        setStates([])
        getCustomerStates(country_id).then(res => {
            const stateData = res.data
            if (stateData.success) {
                setStates(stateData.data)
            }
            if (stateData.error) {
                console.log('Error occured while loading states!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getStates `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    return (
        <React.Fragment>
            <Row id="destination-zone">
                <Col lg={12} className="mb-2">
                    <Col lg={6}>
                        <AppFormikInputInline
                            formik={formik}
                            stFormClass={"st-form-with-label-right d-flex flex-wrap align-items-center mb-1"}
                            labelName={"Zone Name"}
                            inputType={"text"}
                            isRequired={false}
                            placeholder={"Zone Name"}
                            formikFieldName={"zone_name"}
                        />
                    </Col>
                </Col>
                <Col lg={12} className="d-flex align-items-center">
                    <div>
                        <AppFormikSelectInline
                            formik={formik}
                            stFormClass={"d-flex flex-wrap align-items-center"}
                            labelName={""}
                            isRequired={false}
                            formikFieldName={"country"}
                        >
                            <option value="0">Select Country</option>
                            {/* {(countries && countries.length) && countries.map(item => (
                                <option
                                    key={item.country_id.toString()}
                                    value={item.country_id.toString()}>{item.country}</option>
                            ))
                            } */}
                        </AppFormikSelectInline>
                    </div>
                    <div className="ms-1">
                        <AppFormikSelectInline
                            formik={formik}
                            stFormClass={"d-flex flex-wrap align-items-center"}
                            labelName={""}
                            isRequired={false}
                            formikFieldName={"state"}
                        >
                            <option >Select State</option>
                            {/* {(states && states.length) && states.map(item => (
                                <option
                                    key={item.region_id.toString()}
                                    value={item.region_id.toString()}>{item.region}</option>
                            ))
                            } */}
                        </AppFormikSelectInline>
                    </div>
                    <div className="ms-1">
                        <button className="st-btn no-min-width st-btn-gray st-btn  no-min-width d-flex align-items-center justify-content-center me-2">
                            Clear List
                        </button>
                    </div>
                </Col>
                <Col lg={6} className="mt-4">
                    <div className="card bg-gray">
                        <div className=" p-2 text-center st-fs-16 st-fw-600 text__dark-color st-border-light">Add Selected</div>
                        <div className="p-2 bg-white selected-zone">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>United States</div>
                                <div
                                    className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                >
                                    <FeatherIcon
                                        icon="trash-2"
                                        size="11"
                                        className="icon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={12} className="mt-4">
                    <div className="card ">
                        <div className="bg-gray p-2 text-center st-fs-16 st-fw-600 text__dark-color st-border-light">Add Selected</div>
                        <Row>
                            <Col lg={6} className="pe-0">
                                <div className="p-2 bg-white selected-zone mt-3">
                                    <AppFormikTextarea
                                        formik={formik}
                                        stFormClass={"mb-0"}
                                        labelName={""}
                                        placeholder={"Meta Description"}
                                        textareaRows={"4"}
                                        formikFieldName={"metaDescription"}
                                    />
                                </div>
                            </Col>
                            <Col lg={6} className="ps-0">
                                <div className="p-2 bg-white selected-zone">
                                    <p >
                                        List ZIP/Postal codes if you want to limit the zone to specific locations. Only addresses that match these codes will fall into the zone. Enter one code per line.</p>
                                    <p>You can use patterns to add large numbers of codes more easily. Use '?' and '*' as wild card symbols. '?' replaces any character, '*' replaces any number of characters (including zero). Spaces are ignored. '_' replaces any number of spaces (at least one).
                                    </p>
                                    <p className="mt-3">If you need to add all zip codes in an area except a few ones, you can list the codes you don’t want to be in the zone as exclusions. To do that, start a line with '^' and enter the code or code pattern. Addresses will fall into this zone only if they don’t match these ZIP/Postal codes.</p>
                                    <p className="mt-3">If you have both added and excluded codes, only the addresses that match the added codes and don’t match the excluded codes will fall into the zone.</p>
                                    <div>
                                        Example:<br />
                                        2204*<br />
                                        38?45<br />
                                        23*<br />
                                        123_4??<br />
                                        ^22041
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </React.Fragment >
    )
}

export default memo(DestinationZonesDetails)